import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeModal: '',
  modalOrigin: '',
};

const templateModalSlice = createSlice({
  name: 'templateModal',
  initialState,
  reducers: {
    setActiveModal(state, { payload }) {
      state.activeModal = payload.activeModal;
      state.modalOrigin = payload.modalOrigin;
    },
  },
});

export const { setActiveModal } = templateModalSlice.actions;
export default templateModalSlice.reducer;
